import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const GetAllRecords = {
  name: 'displays',
  state: {
    data: [],
    allRecords: [],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: [
      'Display Name',
      'Location name',
      'Display Location',
      'Resolution',
      'Active Ads',
      '# Advertisers',
      'Visibility',
      'Visibility Status',
      'Layout',
      // 'Status',
    ],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },

    getReceived(state, payload) {
      // eslint-disable-next-line array-callback-return
      payload.data = payload.data.map((item) => {
        item.active_ads = `${item.active_ads} Ads`;
        item.advertisers = `${item.advertisers} Adv`;
        item.available = item?.rate_schedule_id ? true : false;
        delete item.org_id;
        delete item.rate_schedule_id;
        return item;
      });
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
        allRecords: payload.allRecords,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({
      page,
      size,
      search,
      sorted_by,
      sort,
      invite = false,
      advertiser_org_id,
      active = true,
      deleted = false,
    }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let url = `savvy/displays/by-organization-id/${userInfo?.org_id}?page=${page}&size=${size}`;

        url += `&invite=${invite ? 'true' : 'false'}`;

        if (advertiser_org_id) {
          url += `&advertiser_org_id=${advertiser_org_id}`;
        }

        if (active === true) {
          url += '&active=1';
        } else if (active === false) {
          url += '&active=0';
        }

        if (deleted === false) {
          url += '&deleted=false';
        } else if (deleted === true) {
          url += '&deleted=true';
        }

        if (search) {
          url = url + `&search="${search}"`;
        }
        if (sorted_by) {
          url = url + `&sorted_by=${sorted_by}`;
        }
        if (sort) {
          url = url + `&sort=${sort}`;
        }
        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data.count,
          allRecords: response.data.data.allData
        });

      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetAllRecords;
